import type { ParticipantAccessLevel } from "@app/common/types";

interface AccessLevelConfig {
  value: ParticipantAccessLevel;
  label: string;
  shortLabel: string;
  description: string;
  default?: boolean;
}

export const PARTICIPANT_ACCESS_OPTIONS: {
  internal: AccessLevelConfig[];
  external: AccessLevelConfig[];
} = {
  internal: [
    {
      value: "editor",
      shortLabel: "editor",
      label: "Editor access",
      description:
        "Internal participants can view and edit the report, and change report access for individuals",
      default: true,
    },
    {
      value: "viewer_full",
      shortLabel: "viewer",
      label: "Viewer access",
      description: "Internal participants can view the report",
    },
    {
      value: "no_access",
      shortLabel: "none",
      label: "No access",
      description: "Internal participants do not get access to meeting reports",
    },
  ],
  external: [
    {
      value: "editor",
      shortLabel: "editor",
      label: "Editor access",
      description:
        "External participants can view and edit the report, and change report access for individuals",
    },
    {
      value: "viewer_full",
      label: "Viewer access",
      description: "External participants can view the report",
      shortLabel: "viewer",
      default: true,
    },
    {
      value: "no_access",
      label: "No access",
      description: "External participants do not get access to meeting reports",
      shortLabel: "none",
    },
  ],
};
